import { render, staticRenderFns } from "./book.view.vue?vue&type=template&id=07fe1c63&scoped=true"
import script from "./book.view.vue?vue&type=script&lang=js"
export * from "./book.view.vue?vue&type=script&lang=js"
import style0 from "./book.view.vue?vue&type=style&index=0&id=07fe1c63&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07fe1c63",
  null
  
)

export default component.exports